export const FETCH_PROCESSES_ERRORS = {
  NO_OP_ACCOUNT: 'get_processes.no_op_account',
  MISSING_CREDENTIALS: 'get_processes.missing_credentials',
  BLOCKED_ACCOUNT: 'get_processes.blocked_gcop_account',
  INVALID_CREDENTIALS: 'get_processes.invalid_credentials',
  GCOP_PROBLEMS: 'get_processes.gcop_problems',
  NOT_CONFIGURED_INSTALLATION_LIST: 'get_processes.not_configured_installation_list',
  NOT_ACCEPTED_DOCUMENTS: 'get_processes.not_accepted_documents',
  SEARCH_DISABLED: 'get_processes.search_processes_disabled',
  SERVICE_NOT_ACTIVATED: 'get_processes.service_not_activated',
  REDIRECT_BRAND: 'get_processes.redirect_brand',
  DISABLED_PROCESS_SEARCH: 'get_processes.disabled_process_search',
  CUSTOMER_BLOCKED: 'get_processes.customer_blocked',
  DEFAULT: 'get_processes.default',
  NETWORK_FAILED: 'get_processes.network_failed',
  MISSING_FIELDS: 'get_processes.missing_fields',
  UNKNOWN_VERSION: 'get_processes.unknown_version',
  NO_USER: 'get_processes.no_user',
  HOUSE_ID_IS_MISSING: 'get_processes.house_id_is_missing',
  HOUSE_IS_MISSING: 'get_processes.house_is_missing',
  NO_CONNECTION_MEMBERS: 'get_processes.no_connection_members',
} as const;

// shown above the process list when OPM marks processes as possibly outdated
export const STALE_PROCESSES_NOTICE = 'Die angezeigten ONLINE PLUS Daten sind möglicherweise nicht aktuell.';

// same text as the backend's get_processes.default, used when the backend sends no description
export const PROCESSES_DEFAULT_ERROR_MESSAGE =
  'ONLINE PLUS konnte nicht verbunden werden. Bitte versuchen Sie es später erneut. Wenn das Problem bestehen bleibt, wenden Sie sich an Ihren Ansprechpartner beim Großhändler.';
